import zhCN from '@/locales/zh-CN';
import enUS from '@/locales/en-US';
import zhTW from '@/locales/zh-TW';
import zhCN_antd from 'antd/lib/locale/zh_CN';
import enUS_antd from 'antd/lib/locale/en_US';
import zhTW_antd from 'antd/lib/locale/zh_TW';
import 'moment/locale/zh-cn';

export default {
  'zh-CN': {
    locale: 'zh-CN',
    label: '简体中文',
    icon: '🇨🇳',
    messages: zhCN,
    antd: zhCN_antd,
  },
  'zh-TW': {
    locale: 'zh-TW',
    label: '繁體中文',
    icon: '🇭🇰',
    messages: zhTW,
    antd: zhTW_antd,
  },
  'en-US': {
    locale: 'en-US',
    label: 'English',
    icon: '🇬🇧',
    messages: enUS,
    antd: enUS_antd,
  },
};
